const shopPlanOptions = {
  wheelsAndbreaks: "KEF/WHEELS & BRAKES",
  oxygen:"KEF/OXYGEN",
  avionics:"KEF/AVIONICS",
  component:"KEF/COMPONENT",
  composite:"KEF/COMPOSITES",
  engine:"KEF/ENGINE",
  interior:"KEF/INTERIOR",
  ndt:"KEF/NDT",
  sheetMetal:"KEF/SHEET METAL",
  weldingAndMachine:"KEF/WELDING & MACHINING", 
} as const;

export {
  shopPlanOptions
}